import { useEffect, useState } from 'react';
import { Container, Nav, Navbar, NavItem } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { sha256 } from 'js-sha256';
import { clearLocalSession } from './api.js';

function NavigationBar() {
    const navigate = useNavigate();
    const isLoggedIn = localStorage.getItem("disbox_account") !== null || localStorage.getItem("webhookUrl") !== null;

    const onLogout = () => {
        if (!window.confirm("Logout dari Disbox? File kamu tetap aman di Discord, tapi akun perlu login lagi di perangkat ini.")) {
            return;
        }
        // Kunci enkripsi & token login ikut dihapus dari browser ini (aman
        // untuk komputer bersama). Passphrase perlu dimasukkan ulang nanti.
        clearLocalSession();
        navigate("/setup");
    };

    // UserId akun yang SEDANG login, dihitung sama persis seperti
    // DisboxFileManager.create (sha256 dari URL webhook pertama), atau null
    // kalau belum login.
    const getCurrentUserId = () => {
        try {
            const accountRaw = localStorage.getItem("disbox_account");
            const account = accountRaw ? JSON.parse(accountRaw) : null;
            const urls = (account && account.webhookUrls && account.webhookUrls.length > 0)
                ? account.webhookUrls
                : [localStorage.getItem("webhookUrl")].filter(Boolean);
            if (urls.length === 0) return null;
            return sha256(new URL(urls[0].trim()).href);
        } catch (e) {
            return null;
        }
    };

    // Total ukuran berkas HANYA milik akun yang sedang login. Dihitung ulang
    // oleh DisboxFileManager tiap daftar file tersimpan (disbox_<id>_usedBytes),
    // karena daftar akun besar tidak lagi ada di localStorage (lihat
    // tree-store.js). Data lama tanpa angka itu dihitung dari localStorage.
    const readUsedBytes = () => {
        let totalBytes = 0;
        const userId = getCurrentUserId();

        if (userId) {
            const known = localStorage.getItem(`disbox_${userId}_usedBytes`);
            if (known !== null) return Number(known) || 0;
            try {
                const fileTree = JSON.parse(localStorage.getItem(`disbox_${userId}`));

                // Fungsi rekursif untuk masuk ke setiap percabangan anak folder (children)
                const calculateSize = (node) => {
                    if (!node) return;
                    if (node.type === 'file' && node.size) {
                        totalBytes += node.size;
                    }
                    if (node.children) {
                        for (let k in node.children) {
                            calculateSize(node.children[k]);
                        }
                    }
                };

                calculateSize(fileTree);
            } catch (e) {
                console.error("Gagal membaca struktur berkas dari local storage:", e);
            }
        }
        return totalBytes;
    };

    // Konversi ukuran bytes ke satuan yang sesuai (Bytes, KB, MB, GB, atau TB)
    const formatBytes = (totalBytes) => {
        if (totalBytes === 0) return "0 Bytes";
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const idx = Math.floor(Math.log(totalBytes) / Math.log(k));
        return parseFloat((totalBytes / Math.pow(k, idx)).toFixed(2)) + ' ' + sizes[idx];
    };

    const [usedBytes, setUsedBytes] = useState(readUsedBytes);
    useEffect(() => {
        const update = () => setUsedBytes(readUsedBytes());
        window.addEventListener('disbox-usage', update);
        return () => window.removeEventListener('disbox-usage', update);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const totalUsedStorage = formatBytes(usedBytes);

    return (
        <Navbar bg="dark" variant="dark" className="font">
            <Container>
                <Navbar.Brand as={Link} to="/"><b style={{ fontSize: "1.3rem" }}>Disbox</b></Navbar.Brand>
                <Navbar.Collapse>
                    <Nav className="me-auto">
                        <NavItem href="/home">
                            <Nav.Link as={Link} to="/home" >Home</Nav.Link>
                        </NavItem>
                        <NavItem href="/setup">
                            <Nav.Link as={Link} to="/setup" >Setup</Nav.Link>
                        </NavItem>
                        {isLoggedIn && (
                            <NavItem>
                                <Nav.Link onClick={onLogout} style={{ cursor: 'pointer' }}>Logout</Nav.Link>
                            </NavItem>
                        )}
                    </Nav>
                    <Nav className="ml-auto" style={{ alignItems: 'center' }}>
                        {/* Wadah visual indikator total akumulasi kapasitas unggahan berkas */}
                        <div style={{ 
                            color: '#a3a6aa', 
                            marginRight: '20px', 
                            fontSize: '0.9rem',
                            borderRight: '1px solid #4f545c',
                            paddingRight: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <span style={{ color: '#ffffff', fontWeight: 'bold' }}>Total Upload:</span> 
                            &nbsp; {totalUsedStorage}
                        </div>
                        
                        <NavItem href="https://github.com/DisboxApp/web">
                            <Nav.Link href="https://github.com/DisboxApp/web" target="_blank" rel="noopener noreferrer">Source code</Nav.Link>
                        </NavItem>
                        <NavItem href="https://github.com/DisboxApp/web/issues">
                            <Nav.Link href="https://github.com/DisboxApp/web/issues" target="_blank" rel="noopener noreferrer">Report problems</Nav.Link>
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavigationBar;